import { EnvironmentProviders } from '@angular/core';
import { initializeApp as angularInitializeApp, provideFirebaseApp } from '@angular/fire/app';
import {
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  provideFirestore
} from '@angular/fire/firestore';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { Capacitor } from '@capacitor/core';
import { environment } from '../environment/environment';

export function provideFirebase(): EnvironmentProviders[] {
  return [
    provideFirebaseApp(() => angularInitializeApp(environment.firebase)),
    provideFirestore(() => {
      if (Capacitor.isNativePlatform()) {
        return initializeFirestore(angularInitializeApp(environment.firebase), {
          localCache: persistentLocalCache({
            tabManager: persistentMultipleTabManager()
          }),
          experimentalForceLongPolling: false,
          experimentalAutoDetectLongPolling: true
        });
      } else {
        return getFirestore();
      }
    }),
    provideAuth(() => getAuth())
  ];
}
